import { ReactNode } from "react";
import styled from "styled-components";
import mediaQueries from "~/guidelines/Theme/mediaQueries";
import { body1, heading7 } from "~/guidelines/Typography";

const Container = styled.dl`
  margin: 0;
  padding: ${({ theme }) => theme.spacing(6)};

  ${mediaQueries.md()} {
    max-width: 380px;
  }
`;

const Title = styled.dt`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(4)};
  align-items: center;

  ${heading7};
  line-height: 24px;
`;

const Content = styled.dd`
  ${body1};
  margin: 0;
  padding: 0;
  padding-top: ${({ theme }) => theme.spacing(5)};
`;

const LabeledInformation = ({
  title,
  icon,
  children,
  className,
}: {
  title: string | ReactNode;
  icon: ReactNode;
  children: ReactNode;
  className?: string;
}) => {
  return (
    <Container className={className}>
      <Title>
        {icon} {title}
      </Title>
      <Content>{children}</Content>
    </Container>
  );
};

export default LabeledInformation;
